import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isSchedulingSelectionItem } from 'owa-calendar-scheduling-grid';
import transformUserFriendlyAllDayToServiceFriendlyAllDay from 'owa-calendar-forms-common/lib/utils/transformUserFriendlyAllDayToServiceFriendlyAllDay';

/**
 * Within the compose form the selection item all day events have 1 day
 * trimmed from the end time for ease of display to the user.  This displays
 * the dates correctly in most cases within the compose form, but not within
 * the scheduling grid so we want to undo this process only for the purpose
 * of displaying all day selection items in the scheduling grid.
 *
 * @param event
 * @returns
 */
export default function transformSelectionItemForAllDay(event: CalendarEvent): CalendarEvent {
    return isSchedulingSelectionItem(event) && event?.IsAllDayEvent
        ? transformUserFriendlyAllDayToServiceFriendlyAllDay(event)
        : event;
}
